import Navbar from "../../../components/Navbar/Navbar";
import LabRequestList from "../components/LabRequestList/LabRequestList";

export default function LabRequestListPage() {
    return (
        <>
            <Navbar title="Lab Requests" />
            <div className="page">
                <LabRequestList />
            </div>
        </>
    );
}
